import type { ResourceOccupancyEntry } from '@/shared/api';
import { ConfirmDialog } from '@/shared/components';
import { cancelPrompt } from './resourcePaymentModel';

/**
 * Bestätigung vor dem Aufheben – für jede Art; erst sie schickt bei bezahlten `confirmPaid`. Eine
 * Ablehnung steht im Dialog, der offen bleibt: am Handy läge ein Hinweis oben in der Karte außer
 * Sicht.
 */
export function ResourceCancelDialog({
  entry,
  loading,
  error,
  onClose,
  onConfirm,
}: {
  entry: ResourceOccupancyEntry | null;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: (confirmPaid: boolean) => void;
}) {
  const prompt = entry ? cancelPrompt(entry) : null;
  return (
    <ConfirmDialog
      open={prompt !== null}
      onOpenChange={(open) => !open && onClose()}
      title={prompt?.title ?? ''}
      description={
        <>
          {prompt?.description}
          {error && (
            <span role="alert" className="text-sealwax mt-2 block">
              {error}
            </span>
          )}
        </>
      }
      confirmLabel={prompt?.confirmLabel ?? 'Aufheben'}
      loading={loading}
      onConfirm={() => {
        if (prompt) onConfirm(prompt.confirmPaid);
      }}
    />
  );
}
